export const SAVE_REFERRAL_REPORT_SUCCESS = "SAVE_REFERRAL_REPORT_SUCCESS";
export const SUBMIT_REFERRAL_REPORT_SUCCESS = "SUBMIT_REFERRAL_REPORT_SUCCESS";

export const SENDTOEMPLOYEE_REFERRAL_REPORT = "SENDTOEMPLOYEE_REFERRAL_REPORT";
export const SENDTOEMPLOYEE_REFERRAL_REPORT_SUCCESS = "SENDTOEMPLOYEE_REFERRAL_REPORT_SUCCESS";
export const APPROVE_REFERRAL_REPORT = "APPROVE_REFERRAL_REPORT";
export const APPROVE_REFERRAL_REPORT_SUCCESS = "APPROVEE_REFERRAL_REPORT_SUCCESS";
export const REQUEST_CHANGES_REFERRAL_REPORT = "REQUEST_CHANGES_REFERRAL_REPORT";
export const REQUEST_CHANGES_REFERRAL_REPORT_SUCCESS = "REQUEST_CHANGES_REFERRAL_REPORT_SUCCESS";
export const REJECT_REFERRAL_REPORT = "REJECT_REFERRAL_REPORT";
export const REJECT_REFERRAL_REPORT_SUCCESS = "REJECT_REFERRAL_REPORT_SUCCESS";
export const REQUEST_REFERRAL_REPORT_EDIT = "REQUEST_REFERRAL_REPORT_EDIT";
export const REQUEST_REFERRAL_REPORT_EDIT_SUCCESS = "REQUEST_REFERRAL_REPORT_EDIT_SUCCESS";
